import type { ILoadingIndicatorService } from '@/infrastructure/services/contract/ILoadingIndicatorService'
import { injectable } from 'inversify'

@injectable()
export default class LoadingIndicatorService implements ILoadingIndicatorService {

  public isLoading = false
}
